export default "__VITE_ASSET__I7yr$5NF__"